<template>
  <v-card outlined elevation="0" style="border: none">
    <v-card-title>
      <h3>{{ quote.description }} ({{ quote.wonum }})</h3>
    </v-card-title>
    <v-card-text class="pt-1">
      <v-row class="px-1 mb-1">
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.pageKm.loco", { value: "default" }) }}:</span
            >
            <span class="value">{{ quote.assetnum }}</span>
          </div>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.location", { value: "default" }) }} :</span
            >
            <span class="value">{{ quote.location }}</span>
          </div>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.status", { value: "default" }) }} :</span
            >
            <span class="value"> {{ getStatus(quote.status) }}</span>
          </div>
        </v-col>
        <v-col>
          <div>
            <span class="mtitle"
              >{{
                $t("message.magic.scheduleDate", { value: "default" })
              }} :
            </span>
            <span class="value">{{ formatdate(quote.schedstart) }}</span>
          </div>
          <div>
            <span class="mtitle"
              >{{
                $t("message.magic.executeDate", { value: "default" })
              }} :
            </span>
            <span class="value">{{ formatdate(quote.actfinish) }}</span>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-row class="px-2 mb-2">
        <v-data-table class="data"
          :headers="serviceLineHeaders" :items="quote.serviceLines"
          :hide-default-footer="true">
          <template v-slot:[`item.unitPrice`]="{ item }">
            {{ formatPrice(calculateUnitPrice(item)) }}
          </template>
          <template v-slot:[`item.itemQty`]="{ item }">
            {{ formatPrice(item.itemQty) }}
          </template>
          <template v-slot:[`item.linePrice`]="{ item }">
            {{ formatPrice(item.linePrice) }}
          </template>
          <template v-slot:[`item.service`]="{ item }">
            {{ filterHtml(item.service) }}
          </template>
        </v-data-table>
      </v-row>
      <v-row class="px-3 mb-2">
        <div>
            <span class="mtitle"
              >{{ $t("message.extrawork.quotetotalprice", { value: "default" }) }} :</span
            >
            <span class="value"> {{ formatPrice(getTotalPrice(quote.serviceLines)) }} euros
            </span>
          </div>
      </v-row>

      <v-divider class="mb-4" v-if="showDoclink()"></v-divider>

      <v-row class="mb-2" v-if="showDoclink()">
        <v-col>
          <div>
            <v-data-table
              dense
              :headers="headersDoclink"
              :items="doclinks"
              light
            >
              <template v-slot:[`item.createdate`]="{ item }">
                {{ formatdate(item.createdate) }}
              </template>
              <template
                v-slot:[`item.document`]="{ item }"
                @click="downloadDoclink(item)"
              >
                {{ item.documentName }}
                <v-icon @click="downloadDoclink(item)"> mdi-download</v-icon>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { formatMagicDate } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";
export default {
  props: ["quote", "doclinks"],

  data() {
    return {};
  },
  methods: {

    getStatus(status){
      if(status == "Accepted") {
        return this.$t("message.extrawork.statusvalidated", { value: "default" });
      } else if(status == "Billed") {
        return this.$t("message.extrawork.statusbilled", { value: "default" });
      } else if(status == "Rejected") {
        return this.$t("message.extrawork.quoterejected", { value: "default" });
      } else if(status == "Waiting for validation") {
        return this.$t("message.extrawork.tovalidate", { value: "default" });
      } else return status;
    },

    getTotalPrice(serviceLines){
      return serviceLines.map(l => parseFloat(l.linePrice)).reduce((a, b) => a + b, 0);
    },

    formatPrice(price){
      return new Intl.NumberFormat(this.$i18n.locale).format(parseFloat(price).toFixed(2));
    },

    calculateUnitPrice(item){
      return item.linePrice/item.itemQty;
    },

    showDoclink() {
      if (this.doclinks.length > 0) {
        return true;
      }
      return false;
    },

    formatdate(date) {
      return formatMagicDate(date);
    },

    downloadDoclink(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);
      window.open(file_path);
    },

    filterHtml(value) {
      if(value){
        let regex = /(<([^>]+)>)/ig;
        return value.replace(regex, "");
      }
    },
  },
  computed: {
    headersDoclink() {
      return [
        {
          text: this.$t("message.magic.date", { value: "default" }),
          value: "createdate",
        },
        {
          text: this.$t("message.magic.details", { value: "default" }),
          value: "document",
        },
      ];
    },
    serviceLineHeaders() {
      return [
        {
          text: this.$t("message.extrawork.service", { value: "default" }),
          value: "service",
          sortable: true,
        },

        {
          text: this.$t("message.extrawork.unitprice", { value: "default" }),
          value: "unitPrice",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.quantity", { value: "default" }),
          value: "itemQty",
          sortable: true,
        },
        {
          text: this.$t("message.extrawork.totalprice", { value: "default" }),
          value: "linePrice",
          sortable: true,
        },
      ];
    },

  },
};
</script>

<style scoped>

:deep(.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th) {
  border: none;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bolder;
}

.value {
  font-size: 16px;
}

.data{
  width: 100%;
}
</style>
